import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';
export interface ServiceOptionProps {
  openServiceOptionDialog: boolean;
  serviceId: number | null;
  openServiceContextOptionDialog: boolean;
  serviceContextId: number | null;
}

// Define the initial state using that type
const initialState: ServiceOptionProps = {
  openServiceOptionDialog: false,
  serviceId: null,
  openServiceContextOptionDialog: false,
  serviceContextId: null,
};

export const serviceOptionsSlice = createSlice({
  name: 'serviceOptions',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    openOptionDialog: (state, action: PayloadAction<number>) => {
      state.openServiceOptionDialog = true;
      state.serviceId = action.payload;
    },
    openContextOptionDialog: (state, action: PayloadAction<number>) => {
      state.openServiceContextOptionDialog = true;
      state.serviceContextId = action.payload;
    },
    closeDialog: () => {
      return initialState;
    },
  },
});

export const { openContextOptionDialog, openOptionDialog, closeDialog } =
  serviceOptionsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectOptionDialog = (state: RootState) =>
  state.serviceOptions.openServiceOptionDialog;
export const selectContextOptionDialog = (state: RootState) =>
  state.serviceOptions.openServiceContextOptionDialog;
export const selectServiceId = (state: RootState) => state.serviceOptions.serviceId;
export const selectServiceContextId = (state: RootState) => state.serviceOptions.serviceContextId;

export default serviceOptionsSlice.reducer;
